    <div class="alert mb-5 mt-5" [ngClass]="(success ? 'alert-success' : 'alert-danger')">
        <span *ngIf="customSuccessMessage && success; else defaultSuccessMessage ">{{customSuccessMessage}}</span>
        <span *ngIf="customErrorMessage && !success; else defaultErrorMessage ">{{customErrorMessage}}</span>

        <ng-template #defaultSuccessMessage>
            <span *ngIf="success">Formularul a fost trimis cu succes!</span>
        </ng-template>

        <ng-template #defaultErrorMessage>
            <span *ngIf="!success">Ceva nu a functionat. Te rugam sa mai incerci o data.</span>
        </ng-template>
    </div>
